import type { SymbolNotes } from '@thinkalpha/platform-ws-client/contracts/user-preference.js';
import { api } from 'src/api';

/**
 * Get all symbol notes for the current user
 * @returns A record mapping symbol -> note
 */
export async function getAllSymbolNotes(): Promise<SymbolNotes> {
    const response = await api.get<SymbolNotes>('/user-preferences/symbol-notes', {
        // 404 means no notes saved yet
        // TODO: Remove 500 from validateStatus once backend bug is fixed (should only return 404 for no notes)
        validateStatus: (status) => (status >= 200 && status < 300) || status === 404 || status === 500,
    });

    if (response.status === 404 || response.status === 500) {
        return {};
    }

    return response.data;
}

/**
 * Get note for a specific symbol
 */
export async function getSymbolNote(symbol: string): Promise<string | null> {
    const response = await api.get<{ note: string } | null>(
        `/user-preferences/symbol-notes/${encodeURIComponent(symbol)}`,
    );
    return response.data?.note ?? null;
}

/**
 * Save or update note for a symbol
 */
export async function saveSymbolNote(symbol: string, note: string): Promise<void> {
    await api.put(`/user-preferences/symbol-notes/${encodeURIComponent(symbol)}`, note, {
        headers: { 'Content-Type': 'text/plain' },
    });
}

/**
 * Delete note for a symbol
 */
export async function deleteSymbolNote(symbol: string): Promise<void> {
    await api.delete(`/user-preferences/symbol-notes/${encodeURIComponent(symbol)}`);
}
